import {
  Design,
  ObjectClass,
  WorkflowPrompt
} from '@app/types';
import { getTypedEntries } from '../object';
import { getWfsPrompt } from './get-wfs-prompt';

export function getWfsPrompts(serialized: Design): WorkflowPrompt[] {
  const serializedPrompts = [
    ...serialized.components.modules.flatMap(({ versions }) => {
      return versions[1].flow.nodes;
    }),
    ...serialized.components.objects
  ].filter(({ _class }) => {
    return _class === ObjectClass.prompt;
  });

  const uniquePrompts = new Map<string, WorkflowPrompt>();
  serializedPrompts.flatMap((prompt) => {
    return getWfsPrompt(serialized, prompt);
  }).forEach((wfsPrompt) => {
    const uniquePrompt = uniquePrompts.get(wfsPrompt.name!);
    if (!uniquePrompt) {
      uniquePrompts.set(wfsPrompt.name!, wfsPrompt);
      return;
    }
    getTypedEntries(wfsPrompt.text).forEach(([key, value]) => {
      uniquePrompt.text[key] ||= value;
    });
  });

  return [...uniquePrompts.values()].sort((wfsPromptA, wfsPromptB) => {
    return wfsPromptA.name!.localeCompare(wfsPromptB.name!);
  });
}
